import * as TYPES from "./pushNotificationActionTypes";

export function setNotifications(value) {
  return { type: TYPES.PUSH_NOTIFICATIONS, value };
}
